export class SiemAccountModel {
    id;
    name;
    created;
}
//# sourceMappingURL=siem-account.js.map